package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings5 {
  internal val missing_words: StringResource by lazy { init_missing_words() }

  internal val missing_words_3_dots: StringResource by lazy { init_missing_words_3_dots() }

  internal val missing_words_underline: StringResource by lazy { init_missing_words_underline() }

  internal val monthly_subscription: StringResource by lazy { init_monthly_subscription() }

  internal val more_open_questions: StringResource by lazy { init_more_open_questions() }

  internal val more_shonot: StringResource by lazy { init_more_shonot() }

  internal val move_cursor_left: StringResource by lazy { init_move_cursor_left() }

  internal val move_cursor_right: StringResource by lazy { init_move_cursor_right() }

  internal val move_left: StringResource by lazy { init_move_left() }

  internal val move_right: StringResource by lazy { init_move_right() }

  internal val move_to_next_book: StringResource by lazy { init_move_to_next_book() }

  internal val move_to_previous_book: StringResource by lazy { init_move_to_previous_book() }

  internal val multiple_choice_questions: StringResource by lazy { init_multiple_choice_questions()
      }

  internal val my_name: StringResource by lazy { init_my_name() }

  internal val names_topic_sentence: StringResource by lazy { init_names_topic_sentence() }

  internal val names_topic_title: StringResource by lazy { init_names_topic_title() }

  internal val neshama: StringResource by lazy { init_neshama() }

  internal val new_game_pair_matching: StringResource by lazy { init_new_game_pair_matching() }

  internal val new_test: StringResource by lazy { init_new_test() }

  internal val new_verse: StringResource by lazy { init_new_verse() }

  internal val new_version_is_available: StringResource by lazy { init_new_version_is_available() }

  internal val next_pyramid: StringResource by lazy { init_next_pyramid() }

  internal val next_question: StringResource by lazy { init_next_question() }

  internal val night_mode: StringResource by lazy { init_night_mode() }

  internal val nikud: StringResource by lazy { init_nikud() }

  internal val nikud_signs: StringResource by lazy { init_nikud_signs() }

  internal val no_highlights: StringResource by lazy { init_no_highlights() }

  internal val no_internet_connection: StringResource by lazy { init_no_internet_connection() }

  internal val no_more_pyramids: StringResource by lazy { init_no_more_pyramids() }

  internal val no_more_questions: StringResource by lazy { init_no_more_questions() }

  internal val no_more_questions_to_this_mikud: StringResource by lazy {
      init_no_more_questions_to_this_mikud() }

  internal val no_pairs: StringResource by lazy { init_no_pairs() }

  internal val no_questions_for_this_mikud: StringResource by lazy {
      init_no_questions_for_this_mikud() }

  internal val no_results_found: StringResource by lazy { init_no_results_found() }

  internal val no_search_results: StringResource by lazy { init_no_search_results() }

  internal val not_matched_to: StringResource by lazy { init_not_matched_to() }

  internal val not_now: StringResource by lazy { init_not_now() }

  internal val now_full_version_is_available: StringResource by lazy {
      init_now_full_version_is_available() }

  internal val numbers_by_books: StringResource by lazy { init_numbers_by_books() }

  internal val ok: StringResource by lazy { init_ok() }

  internal val one_time_payment: StringResource by lazy { init_one_time_payment() }

  internal val onqelos: StringResource by lazy { init_onqelos() }

  internal val open_bookmark: StringResource by lazy { init_open_bookmark() }

  internal val open_in_browser: StringResource by lazy { init_open_in_browser() }

  internal val open_questions: StringResource by lazy { init_open_questions() }

  internal val open_questions_credit_sentence: StringResource by lazy {
      init_open_questions_credit_sentence() }

  internal val open_questions_credit_sentence_linked_word: StringResource by lazy {
      init_open_questions_credit_sentence_linked_word() }

  internal val open_questions_instruction: StringResource by lazy {
      init_open_questions_instruction() }

  internal val open_questions_refreshing_questions: StringResource by lazy {
      init_open_questions_refreshing_questions() }

  internal val open_questions_refreshing_topics: StringResource by lazy {
      init_open_questions_refreshing_topics() }

  internal fun values(): List<StringResource> = listOf(missing_words, missing_words_3_dots,
      missing_words_underline, monthly_subscription, more_open_questions, more_shonot,
      move_cursor_left, move_cursor_right, move_left, move_right, move_to_next_book,
      move_to_previous_book, multiple_choice_questions, my_name, names_topic_sentence,
      names_topic_title, neshama, new_game_pair_matching, new_test, new_verse,
      new_version_is_available, next_pyramid, next_question, night_mode, nikud, nikud_signs,
      no_highlights, no_internet_connection, no_more_pyramids, no_more_questions,
      no_more_questions_to_this_mikud, no_pairs, no_questions_for_this_mikud, no_results_found,
      no_search_results, not_matched_to, not_now, now_full_version_is_available, numbers_by_books,
      ok, one_time_payment, onqelos, open_bookmark, open_in_browser, open_questions,
      open_questions_credit_sentence, open_questions_credit_sentence_linked_word,
      open_questions_instruction, open_questions_refreshing_questions,
      open_questions_refreshing_topics)
}

private fun init_missing_words(): StringResource = StringResource(key = "missing_words", loader =
    stringsLoader)

private fun init_missing_words_3_dots(): StringResource = StringResource(key =
    "missing_words_3_dots", loader = stringsLoader)

private fun init_missing_words_underline(): StringResource = StringResource(key =
    "missing_words_underline", loader = stringsLoader)

private fun init_monthly_subscription(): StringResource = StringResource(key =
    "monthly_subscription", loader = stringsLoader)

private fun init_more_open_questions(): StringResource = StringResource(key = "more_open_questions",
    loader = stringsLoader)

private fun init_more_shonot(): StringResource = StringResource(key = "more_shonot", loader =
    stringsLoader)

private fun init_move_cursor_left(): StringResource = StringResource(key = "move_cursor_left",
    loader = stringsLoader)

private fun init_move_cursor_right(): StringResource = StringResource(key = "move_cursor_right",
    loader = stringsLoader)

private fun init_move_left(): StringResource = StringResource(key = "move_left", loader =
    stringsLoader)

private fun init_move_right(): StringResource = StringResource(key = "move_right", loader =
    stringsLoader)

private fun init_move_to_next_book(): StringResource = StringResource(key = "move_to_next_book",
    loader = stringsLoader)

private fun init_move_to_previous_book(): StringResource = StringResource(key =
    "move_to_previous_book", loader = stringsLoader)

private fun init_multiple_choice_questions(): StringResource = StringResource(key =
    "multiple_choice_questions", loader = stringsLoader)

private fun init_my_name(): StringResource = StringResource(key = "my_name", loader = stringsLoader)

private fun init_names_topic_sentence(): StringResource = StringResource(key =
    "names_topic_sentence", loader = stringsLoader)

private fun init_names_topic_title(): StringResource = StringResource(key = "names_topic_title",
    loader = stringsLoader)

private fun init_neshama(): StringResource = StringResource(key = "neshama", loader = stringsLoader)

private fun init_new_game_pair_matching(): StringResource = StringResource(key =
    "new_game_pair_matching", loader = stringsLoader)

private fun init_new_test(): StringResource = StringResource(key = "new_test", loader =
    stringsLoader)

private fun init_new_verse(): StringResource = StringResource(key = "new_verse", loader =
    stringsLoader)

private fun init_new_version_is_available(): StringResource = StringResource(key =
    "new_version_is_available", loader = stringsLoader)

private fun init_next_pyramid(): StringResource = StringResource(key = "next_pyramid", loader =
    stringsLoader)

private fun init_next_question(): StringResource = StringResource(key = "next_question", loader =
    stringsLoader)

private fun init_night_mode(): StringResource = StringResource(key = "night_mode", loader =
    stringsLoader)

private fun init_nikud(): StringResource = StringResource(key = "nikud", loader = stringsLoader)

private fun init_nikud_signs(): StringResource = StringResource(key = "nikud_signs", loader =
    stringsLoader)

private fun init_no_highlights(): StringResource = StringResource(key = "no_highlights", loader =
    stringsLoader)

private fun init_no_internet_connection(): StringResource = StringResource(key =
    "no_internet_connection", loader = stringsLoader)

private fun init_no_more_pyramids(): StringResource = StringResource(key = "no_more_pyramids",
    loader = stringsLoader)

private fun init_no_more_questions(): StringResource = StringResource(key = "no_more_questions",
    loader = stringsLoader)

private fun init_no_more_questions_to_this_mikud(): StringResource = StringResource(key =
    "no_more_questions_to_this_mikud", loader = stringsLoader)

private fun init_no_pairs(): StringResource = StringResource(key = "no_pairs", loader =
    stringsLoader)

private fun init_no_questions_for_this_mikud(): StringResource = StringResource(key =
    "no_questions_for_this_mikud", loader = stringsLoader)

private fun init_no_results_found(): StringResource = StringResource(key = "no_results_found",
    loader = stringsLoader)

private fun init_no_search_results(): StringResource = StringResource(key = "no_search_results",
    loader = stringsLoader)

private fun init_not_matched_to(): StringResource = StringResource(key = "not_matched_to", loader =
    stringsLoader)

private fun init_not_now(): StringResource = StringResource(key = "not_now", loader = stringsLoader)

private fun init_now_full_version_is_available(): StringResource = StringResource(key =
    "now_full_version_is_available", loader = stringsLoader)

private fun init_numbers_by_books(): StringResource = StringResource(key = "numbers_by_books",
    loader = stringsLoader)

private fun init_ok(): StringResource = StringResource(key = "ok", loader = stringsLoader)

private fun init_one_time_payment(): StringResource = StringResource(key = "one_time_payment",
    loader = stringsLoader)

private fun init_onqelos(): StringResource = StringResource(key = "onqelos", loader = stringsLoader)

private fun init_open_bookmark(): StringResource = StringResource(key = "open_bookmark", loader =
    stringsLoader)

private fun init_open_in_browser(): StringResource = StringResource(key = "open_in_browser", loader
    = stringsLoader)

private fun init_open_questions(): StringResource = StringResource(key = "open_questions", loader =
    stringsLoader)

private fun init_open_questions_credit_sentence(): StringResource = StringResource(key =
    "open_questions_credit_sentence", loader = stringsLoader)

private fun init_open_questions_credit_sentence_linked_word(): StringResource = StringResource(key =
    "open_questions_credit_sentence_linked_word", loader = stringsLoader)

private fun init_open_questions_instruction(): StringResource = StringResource(key =
    "open_questions_instruction", loader = stringsLoader)

private fun init_open_questions_refreshing_questions(): StringResource = StringResource(key =
    "open_questions_refreshing_questions", loader = stringsLoader)

private fun init_open_questions_refreshing_topics(): StringResource = StringResource(key =
    "open_questions_refreshing_topics", loader = stringsLoader)

public actual val SharedRes.strings.missing_words: StringResource
  get() = CommonMainStrings5.missing_words

public actual val SharedRes.strings.missing_words_3_dots: StringResource
  get() = CommonMainStrings5.missing_words_3_dots

public actual val SharedRes.strings.missing_words_underline: StringResource
  get() = CommonMainStrings5.missing_words_underline

public actual val SharedRes.strings.monthly_subscription: StringResource
  get() = CommonMainStrings5.monthly_subscription

public actual val SharedRes.strings.more_open_questions: StringResource
  get() = CommonMainStrings5.more_open_questions

public actual val SharedRes.strings.more_shonot: StringResource
  get() = CommonMainStrings5.more_shonot

public actual val SharedRes.strings.move_cursor_left: StringResource
  get() = CommonMainStrings5.move_cursor_left

public actual val SharedRes.strings.move_cursor_right: StringResource
  get() = CommonMainStrings5.move_cursor_right

public actual val SharedRes.strings.move_left: StringResource
  get() = CommonMainStrings5.move_left

public actual val SharedRes.strings.move_right: StringResource
  get() = CommonMainStrings5.move_right

public actual val SharedRes.strings.move_to_next_book: StringResource
  get() = CommonMainStrings5.move_to_next_book

public actual val SharedRes.strings.move_to_previous_book: StringResource
  get() = CommonMainStrings5.move_to_previous_book

public actual val SharedRes.strings.multiple_choice_questions: StringResource
  get() = CommonMainStrings5.multiple_choice_questions

public actual val SharedRes.strings.my_name: StringResource
  get() = CommonMainStrings5.my_name

public actual val SharedRes.strings.names_topic_sentence: StringResource
  get() = CommonMainStrings5.names_topic_sentence

public actual val SharedRes.strings.names_topic_title: StringResource
  get() = CommonMainStrings5.names_topic_title

public actual val SharedRes.strings.neshama: StringResource
  get() = CommonMainStrings5.neshama

public actual val SharedRes.strings.new_game_pair_matching: StringResource
  get() = CommonMainStrings5.new_game_pair_matching

public actual val SharedRes.strings.new_test: StringResource
  get() = CommonMainStrings5.new_test

public actual val SharedRes.strings.new_verse: StringResource
  get() = CommonMainStrings5.new_verse

public actual val SharedRes.strings.new_version_is_available: StringResource
  get() = CommonMainStrings5.new_version_is_available

public actual val SharedRes.strings.next_pyramid: StringResource
  get() = CommonMainStrings5.next_pyramid

public actual val SharedRes.strings.next_question: StringResource
  get() = CommonMainStrings5.next_question

public actual val SharedRes.strings.night_mode: StringResource
  get() = CommonMainStrings5.night_mode

public actual val SharedRes.strings.nikud: StringResource
  get() = CommonMainStrings5.nikud

public actual val SharedRes.strings.nikud_signs: StringResource
  get() = CommonMainStrings5.nikud_signs

public actual val SharedRes.strings.no_highlights: StringResource
  get() = CommonMainStrings5.no_highlights

public actual val SharedRes.strings.no_internet_connection: StringResource
  get() = CommonMainStrings5.no_internet_connection

public actual val SharedRes.strings.no_more_pyramids: StringResource
  get() = CommonMainStrings5.no_more_pyramids

public actual val SharedRes.strings.no_more_questions: StringResource
  get() = CommonMainStrings5.no_more_questions

public actual val SharedRes.strings.no_more_questions_to_this_mikud: StringResource
  get() = CommonMainStrings5.no_more_questions_to_this_mikud

public actual val SharedRes.strings.no_pairs: StringResource
  get() = CommonMainStrings5.no_pairs

public actual val SharedRes.strings.no_questions_for_this_mikud: StringResource
  get() = CommonMainStrings5.no_questions_for_this_mikud

public actual val SharedRes.strings.no_results_found: StringResource
  get() = CommonMainStrings5.no_results_found

public actual val SharedRes.strings.no_search_results: StringResource
  get() = CommonMainStrings5.no_search_results

public actual val SharedRes.strings.not_matched_to: StringResource
  get() = CommonMainStrings5.not_matched_to

public actual val SharedRes.strings.not_now: StringResource
  get() = CommonMainStrings5.not_now

public actual val SharedRes.strings.now_full_version_is_available: StringResource
  get() = CommonMainStrings5.now_full_version_is_available

public actual val SharedRes.strings.numbers_by_books: StringResource
  get() = CommonMainStrings5.numbers_by_books

public actual val SharedRes.strings.ok: StringResource
  get() = CommonMainStrings5.ok

public actual val SharedRes.strings.one_time_payment: StringResource
  get() = CommonMainStrings5.one_time_payment

public actual val SharedRes.strings.onqelos: StringResource
  get() = CommonMainStrings5.onqelos

public actual val SharedRes.strings.open_bookmark: StringResource
  get() = CommonMainStrings5.open_bookmark

public actual val SharedRes.strings.open_in_browser: StringResource
  get() = CommonMainStrings5.open_in_browser

public actual val SharedRes.strings.open_questions: StringResource
  get() = CommonMainStrings5.open_questions

public actual val SharedRes.strings.open_questions_credit_sentence: StringResource
  get() = CommonMainStrings5.open_questions_credit_sentence

public actual val SharedRes.strings.open_questions_credit_sentence_linked_word: StringResource
  get() = CommonMainStrings5.open_questions_credit_sentence_linked_word

public actual val SharedRes.strings.open_questions_instruction: StringResource
  get() = CommonMainStrings5.open_questions_instruction

public actual val SharedRes.strings.open_questions_refreshing_questions: StringResource
  get() = CommonMainStrings5.open_questions_refreshing_questions

public actual val SharedRes.strings.open_questions_refreshing_topics: StringResource
  get() = CommonMainStrings5.open_questions_refreshing_topics
